import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { TooltipTypes } from '../../tooltipConstants';
import { isHri } from '../../targetApplication';
import { TEXT_KEY, getText } from '../../localization';
import { isMobile } from 'react-device-detect';
import store from '../../../state/store';
export var missionFinished = function missionFinished() {
  return {
    popUpType: TooltipTypes.MISSIONS,
    title: getText(TEXT_KEY.MISSION_DONE_CLAIM_REWARD_TOOLTIP),
    animationState: 'AnimationSlideFromTop',
    style: {
      zIndex: 1000,
      left: tooltipPositionCheck()
    }
  };
};
export var missionInDangerZone = function missionInDangerZone() {
  return {
    popUpType: TooltipTypes.MISSIONS,
    title: getText(TEXT_KEY.MISSION_ENDS_SOON_TOOLTIP),
    animationState: 'AnimationSlideFromTop',
    style: {
      zIndex: 1000,
      left: tooltipPositionCheck()
    }
  };
};
var tooltipPositionCheck = function tooltipPositionCheck() {
  var _state$properties$dat, _state$properties;
  var _window = window,
    width = _window.innerWidth;
  var state = store.getState();
  var showLinkLoyaltyCardSetting = (_state$properties$dat = state === null || state === void 0 || (_state$properties = state.properties) === null || _state$properties === void 0 || (_state$properties = _state$properties.data) === null || _state$properties === void 0 ? void 0 : _state$properties.showLinkLoyaltyCardSetting) !== null && _state$properties$dat !== void 0 ? _state$properties$dat : false;
  var leftPosition;
  if (isHri && isMobile && !showLinkLoyaltyCardSetting) {
    leftPosition = '74%';
  } else {
    leftPosition = isMobile && !showLinkLoyaltyCardSetting ? '71%' : width < 1700 ? '64%' : '62%';
  }
  return leftPosition;
};
export var getBattlesInProgressTooltipDetail = function getBattlesInProgressTooltipDetail(targetElementId) {
  var _window2 = window,
    width = _window2.innerWidth;
  var targetElement = document.getElementById(targetElementId);
  if (!targetElement) return null;
  var rect = targetElement.getBoundingClientRect();
  var detail = {
    popUpType: TooltipTypes.BATTLES_IN_PROGRESS
  };
  detail = _objectSpread(_objectSpread({}, detail), {}, {
    animationState: 'AnimationSlideFromTop',
    style: {
      zIndex: 1000,
      left: rect.left + rect.width / 2 - (width < 1400 ? 260 : 240)
    }
  });
  return detail;
};